import React from 'react';
import { Box, Typography } from '@mui/material';
import { InfoOutlined, ErrorOutlineOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const DateStatusIndicator = ({ experiment, status }) => {
  const { t } = useTranslation();
  
  // Skip if no experiment or dates
  if (!experiment?.dateFrom || !experiment?.dateTo) return null;
  
  // Skip for finished/rejected - dates don't matter
  if (status === 'finished' || status === 'rejected') return null;
  
  // Date-only comparisons in local time to avoid UTC parsing issues
  const toLocalDateStart = (s) => {
    const d = new Date(s);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
  };
  const toLocalDateEnd = (s) => {
    const d = new Date(s);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999);
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const startDate = toLocalDateStart(experiment.dateFrom);
  const endDate = toLocalDateEnd(experiment.dateTo);
  
  // Calculate date states (date-only)
  const datesInPast = today > endDate;
  const currentlyActive = today >= startDate && today <= endDate;
  const datesInFuture = today < startDate;

  // Debug logs removed after verification
  
  // Determine what to show based on status and date state
  let isError = false;
  let message = '';
  
  if (status === 'pending' || status === 'accepted') {
    if (datesInPast || currentlyActive) {
      // Both past and active dates need updating for pending/accepted
      message = t('datesNeedUpdate', { defaultValue: 'Dates need update' });
    }
  } else if (status === 'running') {
    if (datesInPast) {
      isError = true;
      message = t('experimentEndedMoveToFinished', { 
        defaultValue: 'Experiment ended - move to finished' 
      });
    } else if (datesInFuture) {
      message = t('notStartedYet', { defaultValue: 'Not started yet' });
    }
  }
  
  // Don't show anything if no message
  if (!message) return null;
  
  const Icon = isError ? ErrorOutlineOutlined : InfoOutlined;
  const iconColor = isError ? '#dc2626' : '#f59e0b';
  
  return (
    <Box 
      sx={{ 
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        mb: '6px',
      }}
    >
      <Icon 
        sx={{ 
          fontSize: '14px',
          color: iconColor,
          opacity: 0.8
        }} 
      />
      <Typography
        sx={{
          fontSize: '11px',
          fontWeight: 500,
          color: '#6b7280',
          letterSpacing: '-0.01em',
          lineHeight: 1
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default DateStatusIndicator;
